import { WinnerBall } from 'constants/common';
import { IBallsCounter } from 'core/widgets/Scoreboard/BallsCounter/types';

export const getTotalGameRounds = (ballCounter: IBallsCounter): number => {
  const totalRounds =
    ballCounter[WinnerBall.BLUE] + ballCounter[WinnerBall.GOLD] + ballCounter[WinnerBall.RED];
  return totalRounds;
};
